<template>
  <div class="sample-page analysis-jobs-body">
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <router-link to="/">Home</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>Run Jobs</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="analysis-jobs-main">
      <a-row>
        <a-col class="job-des-box" :lg="7" :md="9">
          <h1>Run Job</h1>
          <h2><span>1</span>Add your file</h2>
          <div class="job-des">
            <h2 class="job-des-sub">Drag & drop your file or browse.</h2>
            <h3 style="font-weight: 600">File input requirements:</h3>
            <p>
              File format：A tab text file contain 2 columns at least. The first
              column is ENSEMBL ID, and the last column is genes expression
              value.
            </p>
            <h3 style="font-weight: 600">Download Example:</h3>
            <p>
              <a
                href="/download/sample_fpkm_example.txt"
                download="sample_fpkm_example.txt"
                >sample_fpkm.txt</a
              >
            </p>
          </div>

          <h2><span>2</span>Run Job</h2>
          <div class="job-des">
            <h2 class="job-des-sub">Click RUN</h2>
            <p>
              <a href="javascript:;" @click="openExample">Run Example</a>
            </p>
          </div>

          <h2><span>3</span>Check your output file</h2>
          <div class="job-des">
            <h2 class="job-des-sub">
              Click
              <a-icon type="eye" />
            </h2>
          </div>
        </a-col>
        <a-col :lg="17" :md="15" class="job-run-box">
          <h3>Pipeline_BALL6:</h3>
          <h4>
            Description: BALL6 (B-cell Acute Leukemia Subtype Identification based on rank of eXpression): A deep learning tool for predicting AL and B-ALL subtypes based on the expression rank values of 476 selected genes.
          </h4>
          <h4>
            User Guide： How to use/Output summary/Contact us…..
            <router-link to="/analysis/help">learn more</router-link>
          </h4>
          <div class="pipe-img-box" style="text-align: center">
            <embed
              src="/avatar/web-banner-2.svg"
              width="100%"
              height="280px"
              type="image/svg+xml"
              pluginspage="http://www.adobe.com/svg/viewer/install/"
            />
          </div>
          <div v-if="steps == 1">
            <h2 class="title">Add File</h2>
            <a-card class="job-card">
              <a-upload-dragger
                name="file"
                accept=".txt"
                :action="actionUrl"
                :multiple="false"
                :file-list="fileList"
                :remove="handleRemove"
                :beforeUpload="beforeUpload"
                @change="handleChange"
              >
                <p class="ant-upload-drag-icon">
                  <a-icon type="inbox" />
                </p>
                <p class="ant-upload-text">Drag and drop here or</p>
                <p class="jcard-upload-btn"><a-button>Browse file</a-button></p>
                <p class="ant-upload-hint">
                  Support for a single upload. Strictly prohibit from uploading
                  company data or other band files
                </p>
              </a-upload-dragger>
            </a-card>

            <div
              class="job-upload-progress-container"
              v-if="fileList.length !== 0 && fileList[0].status == 'done'"
            >
              <a-button type="primary" class="job-run-btn" @click="submitRun"
                >RUN</a-button
              >
            </div>
          </div>
          <div v-else-if="steps == 2">
            <h2 class="title">RUNNING</h2>
            <a-card class="job-card">
              <div class="job-run-progress">
                <div class="job-run-upload-progress">
                  <span class="job-run-status-text">{{ progress }}%</span>
                  <div
                    class="job-run-status-progress"
                    :style="{ width: progress + '%' }"
                  ></div>
                </div>
                <p class="job-run-upload-text">
                  Job will run for a few minutes, please wait patiently.
                </p>
                <p class="job-run-upload-hint">
                  For jobs that can run without log in, please do not close the
                  page,<br />
                  otherwise you would not be able to view the results.
                </p>
              </div>
            </a-card>
          </div>
          <div v-else>
            <h2 class="title">The Latest Result</h2>
            <a-card
              :class="
                jobsStatus.status !== 'done' ? 'job-result err' : 'job-result'
              "
            >
              <p>Status: {{ jobsStatus.status || "- -" }}</p>
              <p>
                Output:
                <a href="javascript:;" @click="openCheckDetails()">
                  {{ jobsStatus.jobId }}
                  <a-icon type="eye" />
                </a>
              </p>
              <p>Input: {{ fileList[0].response.data || "- -" }}</p>
              <p>
                Start Time：{{
                  $moment(jobsStatus.createTime).format(
                    "YYYY-MM-DD HH:mm:ss"
                  ) || "- -"
                }}
              </p>
              <p>
                End Time：{{
                  $moment(jobsStatus.finishTime).format(
                    "YYYY-MM-DD HH:mm:ss"
                  ) || "- -"
                }}
              </p>
            </a-card>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      publicFile: process.env.BASE_URL,
      actionUrl: "api/open/ps/uploadFile",
      path: process.env.VUE_APP_ANALYSIS_PATH,
      fileList: [],
      steps: 1,
      resRunId: "",
      progress: 0,
      timer: null,
      statusTimer: null,
      jobsStatus: {},
      langTime: 800,
    };
  },
  mounted() {},
  methods: {
    openExample() {
      this.$router.push({
        path: "analysis/details",
        query: { jobsId: "run-example" },
      });
    },
    openCheckDetails() {
      if (this.jobsStatus.jobId) {
        this.$router.push({
          path: "analysis/details",
          query: { jobsId: this.jobsStatus.jobId },
        });
      } else {
        this.$message.error("Job does not exist!");
      }
    },
    handleRemove(file) {
      this.fileList = [];
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
    },
    // 上传前事件
    beforeUpload(file) {
      if (file.name.indexOf(".txt") == -1) {
        this.$message.error("Please upload the file with txt suffix.");
        return false;
      }
      this.fileList = [file];
      return true;
    },
    submitRun() {
      if (this.fileList.length == 0) {
        this.$message.error(
          "Please upload the file with the specified suffix of txt and run."
        );
      } else {
        this.$get("open/ps/job/submit", {
          fpkmFilename: this.fileList[0].response.data,
        }).then((res) => {
          if (res.data.code == 1) {
            this.steps = 2;
            this.resRunId = res.data.data;
            this.loadProgress();
            this.loadStatus(this.resRunId);
          }
        });
      }
    },
    loadProgress() {
      let $this = this;
      this.timer = setInterval(() => {
        if ($this.progress > 99 && $this.progress < 100) {
          clearInterval($this.timer);
        } else {
          $this.progress += 0.8;
          $this.progress = $this.progress.toFixed(2) * 1;
        }
      }, $this.langTime);
    },
    loadStatus(id) {
      let $this = this;
      this.statusTimer = setInterval(() => {
        if ($this.jobsStatus.status == "running") {
          $this.getJobsStatus(id);
        } else if ($this.jobsStatus.status == "done") {
          $this.progress = 100;
          $this.steps = 3;
          clearInterval($this.statusTimer);
        } else {
          clearInterval($this.statusTimer);
        }
      }, 3000);
      $this.getJobsStatus(id);
    },
    getJobsStatus(id) {
      let $this = this;
      this.$get("open/ps/job/status", {
        saasJobId: this.resRunId,
      }).then((res) => {
        if (res.data.code == 1) {
          this.jobsStatus = JSON.parse(res.data.data);
        } else {
          clearInterval($this.statusTimer);
        }
      });
    },
    randomTime(n, m) {
      return (Math.random() * (n - m) + m).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.analysis-jobs-body {
  background: white;
  padding-bottom: 0;
  .pipe-img-box {
    background-color: #fff;
    margin-top: 15px;
    padding-left: 10px;
  }
  .customhouse-breadcrumb {
    background: #e5e5e5;
    padding: 15px 20px;
  }

  .job-des-box {
    padding: 20px 40px;
    line-height: 25px;
    background: white;
  }

  h1 {
    font-size: 3em;
    font-weight: 600;
    padding: 10px 0;
  }

  h2 {
    font-weight: 600;
    padding-top: 25px;
    span {
      display: inline-block;
      margin-right: 20px;
      color: white;
      padding: 2px 10px;
      background: #0162ff;
      border-radius: 20px;
    }
  }
  .job-run-box {
    padding: 20px 40px 50px 40px;
    background: #f3f4f8;
  }

  .job-des-sub {
    color: #9f9f9f;
    font-size: 18px;
    font-weight: 200;
    padding: 5px 0;
  }
  .job-card {
    min-height: 230px;
    margin-bottom: 20px;
    .jcard-upload-btn {
      padding: 12px 0;
    }
  }
  .job-run-progress {
    text-align: center;
    padding: 70px 35px 20px 35px;
    border: 2px dashed #428ef7;
    border-radius: 3px;
    .job-run-upload-progress {
      position: relative;
      width: 300px;
      margin: 0 auto;
      margin-bottom: 5px;
      height: 2px;
      background-color: #e5e5e5;
      border-radius: 32px;
      .job-run-status-progress {
        height: 2px;
        width: 0.1%;
        background-color: #428ef7;
        border-radius: 32px;
      }
      .job-run-status-text {
        position: absolute;
        left: 50%;
        top: -25px;
        margin-left: -10px;
        color: #262626;
        font-size: 14px;
      }
    }
    .job-run-upload-text {
      margin: 0 0 4px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
    }
  }

  .job-upload-progress-container {
    display: flex;
    justify-content: center;
    align-content: center;
    margin-top: 20px;
    padding: 0 20px;
  }

  .job-run-btn {
    width: 50%;
    height: 36px;
  }

  .job-result {
    line-height: 26px;
    &.err {
      border: 1px solid #ea3622;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
    }
  }
}
</style>